import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Access } from "../../models/access";
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class VerifyService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }


  verify(access: Access) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        "p1": access.lucaClaimNumber,
        "p2": access.phone1,
      })
    };

    return this.http.get(this.baseUrl + "verify/creds/", httpOptions);
  }
}
